import { IMAGES } from "./images";

export const COLLECTIONS = [
  {
    id: "royal",
    name: { en: "The Royal Collection", fr: "La Collection Royale" },
    image: IMAGES.royal,
    vehicles: [
      { name: "Rolls-Royce", pax: 3, luggage: 3, category: "Royal", features: ["Handcrafted interior", "Starlight headliner", "Rear privacy suite"], onRequest: true },
      { name: "Mercedes-Maybach", pax: 3, luggage: 3, category: "Royal", features: ["Executive rear seats", "Champagne refrigerator", "Burmester 4D sound"], onRequest: false },
      { name: "Range Rover Autobiography", pax: 4, luggage: 4, category: "Royal", features: ["Executive comfort seats", "Panoramic roof", "Commanding presence"], onRequest: false },
      { name: "Bentley", pax: 3, luggage: 3, category: "Royal", features: ["Diamond-quilted leather", "Naim audio", "Rear entertainment"], onRequest: true },
    ],
  },
  {
    id: "executive",
    name: { en: "The Executive Collection", fr: "La Collection Executive" },
    image: IMAGES.executive,
    vehicles: [
      { name: "Mercedes-Benz S-Class", pax: 3, luggage: 3, category: "Executive", features: ["Reclining rear seats", "Ambient lighting", "Wi-Fi & chargers"], onRequest: false },
      { name: "BMW 7 Series", pax: 3, luggage: 3, category: "Executive", features: ["Executive lounge seating", "Theatre screen", "Sky lounge roof"], onRequest: false },
      { name: "Audi A8", pax: 3, luggage: 3, category: "Executive", features: ["Relaxation seat", "Bang & Olufsen sound", "Quiet cabin"], onRequest: false },
    ],
  },
  {
    id: "van",
    name: { en: "The VIP Van Collection", fr: "La Collection Van VIP" },
    image: IMAGES.van,
    vehicles: [
      { name: "Mercedes-Benz V-Class", pax: 7, luggage: 7, category: "VIP Van", features: ["Conference seating", "Privacy glass", "Generous luggage space"], onRequest: false },
      { name: "VIP V-Class", pax: 4, luggage: 4, category: "VIP Van", features: ["Captain seats", "Ambient cabin lighting", "Onboard refreshments"], onRequest: false },
      { name: "Mercedes-Benz Sprinter VIP", pax: 12, luggage: 12, category: "Group", features: ["Premium group cabin", "Individual seating", "Event coordination"], onRequest: false },
    ],
  },
  {
    id: "exotic",
    name: { en: "The Exotic Collection", fr: "La Collection Exotique" },
    image: IMAGES.exotic,
    partnerNetwork: true,
    vehicles: [
      { name: "Bugatti", pax: 1, luggage: 1, category: "Exotic", features: ["Icon of performance", "Chauffeured or self-drive experience"], onRequest: true },
      { name: "Aston Martin", pax: 1, luggage: 1, category: "Exotic", features: ["British grand touring", "Bespoke interior"], onRequest: true },
      { name: "Ferrari", pax: 1, luggage: 1, category: "Exotic", features: ["Italian excellence", "Unmistakable presence"], onRequest: true },
      { name: "Lamborghini", pax: 1, luggage: 1, category: "Exotic", features: ["Dramatic design", "Event arrivals"], onRequest: true },
      { name: "Porsche", pax: 3, luggage: 2, category: "Exotic", features: ["Precision engineering", "Everyday exotic"], onRequest: true },
      { name: "McLaren", pax: 1, luggage: 1, category: "Exotic", features: ["Lightweight performance", "Rare presence"], onRequest: true },
    ],
  },
];

export const FRANCE_CITIES = ["Paris", "Cannes", "Nice", "Monaco", "Saint-Tropez", "Lyon", "Marseille", "Bordeaux", "Toulouse", "Strasbourg", "Lille", "Biarritz", "Deauville", "French Alps", "French Riviera"];
export const EUROPE_CITIES = ["London", "Geneva", "Zurich", "Milan", "Rome", "Madrid", "Barcelona", "Munich", "Vienna", "Amsterdam", "Brussels", "Luxembourg", "Lisbon", "Prague"];
export const ROUTES = [["Paris", "Monaco"], ["Paris", "Geneva"], ["Paris", "Milan"], ["Nice", "Monaco"], ["Paris", "Cannes"], ["Geneva", "Milan"], ["Paris", "London"], ["Milan", "Rome"]];
export const SERVICE_LANGS = ["English", "Français", "العربية", "中文", "Italiano", "Español", "Deutsch", "Русский"];
